export default __webpack_public_path__ + "static/media/october.ae1e32cb.jpg";